import VerticalTabItem from './VerticalTabItem';
import { VerticalTabItemProps, VerticalTabItemValueProps } from './types';

export type { VerticalTabItemProps, VerticalTabItemValueProps };
export default VerticalTabItem;
